<template>
    <v-menu transition="slide-y-transition" bottom offset-y z-index="140">
        <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon>fas fa-bars</v-icon>
            </v-btn>
        </template>

        <v-list color="#008075" dark>
            <v-list-item v-for="(item, index) in items" :key="index" :to="item.link">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    data: () => ({
        items: [
            { title: "SIG", link: "/" },
            { title: "SCADA", link: "/scada" },
            { title: "Res Canales", link: "/canales" },
            { title: "Res Pozos", link: "/pozos" },
            { title: "Dash Cliente 1", link: "/cliente1" },
            { title: "Dash Cliente 2", link: "/cliente2" },
            { title: "Dash Cliente 3", link: "/cliente3" },
        ]
    }),
}
</script>